export const SnapdocsClosingLoadState = {
  LOADING: 'loading',
  LOADED: 'loaded',
  NO_CLOSING: 'noClosing',
  UNAVAILABLE: 'unavailable',
  ERROR: 'error',
};

export const SnapdocsClosingResource = {
  APPOINTMENT: 'appointment',
  BORROWERS: 'borrowers',
  NOTARY: 'notary',
  QUALITY_CONTROL: 'qualityControl',
  COMMENTS: 'comments',
};
